import * as React from "react";
import Box from "@mui/material/Box";
import {LeadRow} from "./LeadRow";
import "./LeadTable.module.css";

export const LeadTable = (
    {
        data
    }
) => {

    return (
        <>
            {data.length > 0 && (
                data.map((item, index) => (
                    <Box key={item.searchId}>
                        <LeadRow
                            createdDate     ={item.createdDate}
                            updatedDate     ={item.updatedDate}
                            epid            ={item.assignedEpid}
                            availableEpids  ={item.availableEpids}
                            leadStatus      ={item.leadStatus}
                        />
                    </Box>
                ))
            )}
        </>
    )
}